import { gql } from '@apollo/client';

const UPDATE_USER_SECONDARY_PHONE_NUMBERS = gql`
  mutation UpdateUserSecondaryPhoneNumbers($params: UpdateUserSecondaryPhoneNumbersParams!) {
    updateUserSecondaryPhoneNumbers(params: $params)
  }
`;

export default UPDATE_USER_SECONDARY_PHONE_NUMBERS;
